<svg [attr.height]="size" [attr.width]="size" >
   <circle [attr.cx]="center" [attr.cy]="center" [attr.r]="radius" />
   <path *ngFor="let a of arcs" class="pie-ring-{{a.clas}}" [attr.d]="a.argsAsString" />
</svg>
